import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import {
  baseContainer,
  documentContainer,
  documentContainerSlideout,
  documentNameContainer,
  imgContainer,
} from "./styles_vanilla.css";
import { DocumentTrackerProps } from "./types";
export const DocumentTracker: React.FC<DocumentTrackerProps> = ({
  documentName,
  documentUrl,
  slideoutMode = false,
}) => {
  const isImage = /\.(jpe?g|png)$/i.test(documentName);
  const url = `${documentUrl}#toolbar=0&navpanes=0`;

  // Slideout-specific styles - optimized for flexible slideout dimensions
  const slideoutImageStyle = {
    width: "100%",
    height: "auto",
    maxHeight: "calc(100vh - 50px - 68px - 48px)", // Account for nav bar, document name header, and padding
  };

  // Iframe styles for PDFs in slideout mode - prevent cutting off
  const slideoutIframeStyle = {
    width: "100%",
    height: "calc(100vh - 50px - 68px - 48px)", // Use available height for PDFs
    border: "none",
  };

  return (
    <Flex className={baseContainer} flexDirection={"column"}>
      <Flex className={documentNameContainer} alignItems={"center"}>
        <Text variant={"strong-md"}>{documentName}</Text>
      </Flex>
      <Flex
        className={slideoutMode ? documentContainerSlideout : documentContainer}
        flexDirection={"column"}
      >
        {isImage ? (
          <img
            className={slideoutMode ? undefined : imgContainer}
            style={slideoutMode ? slideoutImageStyle : undefined}
            src={documentUrl}
            alt={documentName}
          />
        ) : (
          <iframe
            className={slideoutMode ? undefined : imgContainer}
            style={
              slideoutMode
                ? slideoutIframeStyle
                : { width: "100%", height: "100%", border: "none" }
            }
            src={url}
            title={"Uploaded Supporting Document"}
          />
        )}
      </Flex>
    </Flex>
  );
};
